import React from 'react';
import { ShieldIcon } from 'lucide-react';
import { Section } from './Shared';
import { WhatsAppIcon, WHATSAPP_URL } from './WhatsAppButton';
export const Guarantee = () => <Section className="max-w-3xl" data-id="element-75" data-mp="32nukolv2nz0b">
    <div className="glass-panel gold-frame p-9 md:p-14 rounded-sm text-center" data-id="element-76" data-mp="32onkf2vm5o8y">
      <ShieldIcon className="w-12 h-12 text-brand-gold mx-auto mb-6" data-id="element-77" data-mp="36p6aoshuym91" />
      <p className="font-seal text-[10px] md:text-xs uppercase tracking-seal text-brand-goldDark mb-4" data-id="element-78" data-mp="36n3dnoiafsut">
        Garantía de 7 días — sin preguntas
      </p>
      <h2 className="text-2xl md:text-3xl font-display font-bold mb-6 text-brand-purpleDark" data-id="element-79" data-mp="37o2ul235f8m">
        Abre los tomos. Aplica los protocolos. Utilízalos en tu consulta.
      </h2>
      <p className="text-brand-text/85 mb-6 text-base md:text-lg leading-relaxed" data-id="element-80" data-mp="3qcx86ace0m2q">
        Si en 7 días no es exactamente lo que esperabas, recibes la devolución
        del 100% del importe: sin formularios, sin trámites y sin preguntas.
      </p>
      <p className="text-sm text-brand-muted" data-id="element-81" data-mp="2ezl0tphf5lbt">
        Tasa de devoluciones: menos del 1%.
      </p>
    </div>
  </Section>;
export const Footer = () => <footer className="bg-brand-purpleDark text-brand-surface/80 py-14 border-t border-brand-gold/40" data-id="element-82" data-mp="3gb8x35faxiwn">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-83" data-mp="3v7zvpch5iql7">
      <div className="mb-10" data-id="element-84" data-mp="3q8wrtvcwqqet">
        <h2 className="font-seal text-base md:text-lg uppercase tracking-seal text-brand-goldLight mb-4" data-id="element-85" data-mp="3q7lm3pzwj8l2">
          Lumen Akasha
        </h2>
        <p className="text-brand-surface/70 text-sm md:text-base max-w-2xl mx-auto leading-relaxed" data-id="element-86" data-mp="80xik4ki2thi">
          El sistema clínico n.° 1 para terapeutas de Chi Kung en España. Porque
          aplicar Chi Kung con excelencia no debería costarte la seguridad ni la
          energía de tu consulta.
        </p>
      </div>

      <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 mb-12 text-sm" data-id="element-87" data-mp="qti04pur1c60">
        <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 hover:text-brand-goldLight transition-colors duration-150 ease-out" data-id="element-88" data-mp="ms6dmt769721">
          <WhatsAppIcon className="w-4 h-4 shrink-0" data-id="element-89" data-mp="yuzce09ghjnf" />
          WhatsApp
        </a>
        <a href="mailto:soportelumenakasha@gmail.com" className="hover:text-brand-goldLight transition-colors duration-150 ease-out" data-id="element-90" data-mp="13t0xsructv22">
          soportelumenakasha@gmail.com
        </a>
        <a href="https://instagram.com/lumen.akasha" className="hover:text-brand-goldLight transition-colors duration-150 ease-out" data-id="element-91" data-mp="1ckt2sn0m0bz9">
          @lumen.akasha
        </a>
        <a href="https://www.lumenakasha.com" className="hover:text-brand-goldLight transition-colors duration-150 ease-out" data-id="element-92" data-mp="1ml3ge8qk3ley">
          www.lumenakasha.com
        </a>
      </div>

      <div className="text-xs text-brand-surface/45 space-y-2 border-t border-brand-gold/20 pt-8" data-id="element-93" data-mp="3ocpy1jok63yr">
        <p data-id="element-94" data-mp="3tarrmyjm1loh">
          © Lumen Akasha 2026. Todos los derechos reservados. Prohibida la
          reproducción y la redistribución sin autorización expresa.
        </p>
        <p data-id="element-95" data-mp="25o586ef05jak">
          Protección de datos personales conforme al Reglamento General de
          Protección de Datos (RGPD).
        </p>
      </div>

      <p className="mt-8 text-sm font-display italic text-brand-goldLight/70 max-w-2xl mx-auto" data-id="element-96" data-mp="21kpf1s25612m">
        “El terapeuta que tiene un sistema aplica con confianza. Quien aplica
        con confianza genera resultados. Quien genera resultados, crece.”
      </p>
    </div>
  </footer>;